import { render, staticRenderFns } from "./consignmentinscan.vue?vue&type=template&id=c74123dc&"
import script from "./consignmentinscan.vue?vue&type=script&lang=js&"
export * from "./consignmentinscan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports